import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPackageList } from '../features';

export const usePackages = ({ defaultSelected = null }) => {
  const dispatch = useDispatch();
  const [selectedPackage, setSelectedPackage] = useState(defaultSelected);
  const handlePackageChange = (e) => setSelectedPackage(e.target.value);
  const packageListData = useSelector((state) => state.packageList?.packageMenuList);

  useEffect(() => {
    if (!packageListData) {
      dispatch(getPackageList());
    }
  }, [dispatch]);

  const packageList = useMemo(() => {
    const baseList = (packageListData || [])
      .filter((item) => item.isEnabled !== false)
      .map((item) => ({
        id: item.packageId,
        name: item.packageLabel,
        value: item.packageId,
      }));

    return defaultSelected === '-all-'
      ? [{ id: '-all-', name: 'All Packages', value: '-all-' }, ...baseList]
      : baseList;
  }, [defaultSelected, packageListData]);

  useEffect(() => {
    if (!defaultSelected && packageList.length) {
      setSelectedPackage(packageList[0].value);
    }
  }, [packageList]);

  return {
    packageList,
    selectedPackage,
    setSelectedPackage,
    handlePackageChange,
  };
};
